export default function $chatWamp($wamp) {
  return $wamp;
}
